export default __webpack_public_path__ + "static/media/Deniz.8a69874d.jpeg";